import { Component, Inject, Input} from '@angular/core';
import { ErrorMessageService } from '../../services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'validation-messages',
  templateUrl: './validation-messages.component.html',  
})
export class ValidationMessagesComponent {
  
  constructor(private msgService: ErrorMessageService, private translate: TranslateService) {
    
  }
      
  @Input() msgList: string[] = [];
  @Input() displayErrorTitles = false;
    
  getMessage(key: string): string {
      const msg = this.msgService.getErrorMessage(key);
      return this.translate.instant(msg.translationKey);
  }
}
